import React from 'react';
import { Portal } from '../../portal/Portal';
import { useBundleOfferings } from './BundleOfferingsContext';
import { AddHandler, BundleOffering } from './BundleOffering/BundleOffering';
import { ShopifyStorefrontClient } from '../../../api/shopify/ShopifyStorefrontClient';
import { transformStorefrontCartToJbCart } from '../../../utils/cart/transformStorefrontCartToJbCart';
import { drawCart, setCartLoading } from '../../../utils/legacyCart';

const storefrontClient = new ShopifyStorefrontClient();

export const BundleOfferings = (): JSX.Element => {
  const { title, ctaLabel, bundleOfferings } = useBundleOfferings();

  const handleAdd = async ({ variantId, quantity }: AddHandler) => {
    setCartLoading(true);
    const updatedCart = await storefrontClient.addToCart(variantId, quantity);
    const transformedCart = transformStorefrontCartToJbCart(updatedCart);
    await drawCart(transformedCart);
  };

  return (
    <>
      {bundleOfferings.map(({ containerId, offerings }) => {
        const container = document.getElementById(containerId);
        if (!container) return;

        return (
          <Portal key={containerId} container={container}>
            <BundleOffering title={title} ctaLabel={ctaLabel} offerings={offerings} onAdd={handleAdd} />
          </Portal>
        );
      })}
    </>
  );
};
